
/**
 * Loading recovery utility
 * Detects and handles blank page issues at startup
 */

// Wait for a generous timeout before checking if the page loaded properly
const BLANK_PAGE_TIMEOUT = 8000; // 8 seconds

// Helper function to create a basic fallback UI
const createFallbackUI = () => {
  const rootElement = document.getElementById('root');
  
  // Exit if no root element or if it already has content
  if (!rootElement || rootElement.childElementCount > 0) return;
  
  console.log('[Recovery] Creating fallback UI after timeout');
  
  // Create a simple fallback UI
  rootElement.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:system-ui,sans-serif;">
      <h2 style="margin-bottom:16px">Loading application...</h2>
      <p style="margin-bottom:24px">If content doesn't appear, please try refreshing</p>
      <button 
        onclick="window.location.reload()" 
        style="padding:8px 16px;background:#3b82f6;color:white;border:none;border-radius:4px;cursor:pointer"
      >
        Refresh the page
      </button>
      <p style="margin-top:32px;font-size:12px;color:#666">
        Error code: BWP-${Date.now().toString(36)}
      </p>
    </div>
  `;
};

// Set up blank page detection
if (typeof window !== 'undefined') {
  // Record the initialization time
  const initTime = Date.now();
  
  // Function to check if page has rendered properly
  const checkPageRender = () => {
    // Check if the root element contains any children
    const rootElement = document.getElementById('root');
    const hasContent = rootElement && rootElement.childElementCount > 0;
    
    // Log the check status
    console.log(`[Recovery] Checking page render after ${Date.now() - initTime}ms: ${hasContent ? 'content found' : 'blank page'}`);
    
    // If still blank, create a fallback UI
    if (!hasContent) {
      createFallbackUI();
    }
  };
  
  // Schedule the check after timeout
  setTimeout(checkPageRender, BLANK_PAGE_TIMEOUT);
  
  // Add a listener for visible state changes
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      // When tab becomes visible again, check if content is loaded
      const rootElement = document.getElementById('root');
      const hasContent = rootElement && rootElement.childElementCount > 0;
      
      if (!hasContent && Date.now() - initTime > BLANK_PAGE_TIMEOUT) {
        createFallbackUI();
      }
    }
  });
}

// Export a dummy function so this can be imported as a module
export default function ensureContentLoads() {
  // Implementation is in the file's top level code
  return true;
}
